import { useResource } from "./hooks";

/**
 * PS0: the client's view of the plan flags. Rendering only — every premium
 * route re-checks the flag server-side (requireFeature), so a spoofed client
 * gains nothing but a nicer-looking 403.
 */
export type Feature = "claim_guard" | "autocover" | "pulse" | "care_circle" | "ally";

export interface Entitlements {
    plan: string;
    features: Record<Feature, boolean>;
}

export const FEATURE_LABELS: Record<Feature, { name: string; blurb: string; metered?: boolean }> = {
    claim_guard: { name: "Claim Guard", blurb: "NDIS rate checks before invoicing — catch over- and under-charges before they ship." },
    autocover: { name: "AutoCover", blurb: "Roster gap auto-fill — ranked, compliance-checked candidates with one-click invites." },
    pulse: { name: "Pulse", blurb: "A proactive attention feed — expiries, plan endings and risks surfaced before they bite." },
    care_circle: { name: "Care Circle", blurb: "A read-only portal for participants and their families — roster, shared notes, funding." },
    ally: { name: "Ally", blurb: "The TrustCare AI assistant — answers, drafts and actions within each person's permissions.", metered: true },
};

export const useEntitlements = () => {
    const resource = useResource<Entitlements>("/entitlements");
    const enabled = (feature: Feature): boolean =>
        resource.data?.features?.[feature] === true;
    return { ...resource, enabled, plan: resource.data?.plan ?? "standard" };
};
